import {
    SET_CART_SUMMARY_CHECKOUT_STEP,
    SHOW_SPLASHSCREEN,
    SHOW_LOADING,
    SHOW_MODAL_CART_EXPIRED,
    SHOW_MODAL_CART_TIMER,
    SHOW_MODAL_CART_RESET,
    SHOW_MODAL_ERRORS
} from '../mutations/global';

const global = {
    namespaced: true,
    state: {
        splashscreen_visible: false, //loading iniziale
        loading_visible: false,

        //modal time expired
        modal_cart_expired_error: '',
        show_modal_cart_expired: false,

        //modal timer
        modal_cart_timer_minutes: null,
        show_modal_cart_timer: false,

        //modal reset cart
        modal_cart_reset_callback: () => {
        },
        show_modal_cart_reset: false,

        //modal errors
        modal_errors_title: '',
        modal_errors_errors: [],
        show_modal_errors: false,

        //cart summary
        cart_summary_checkout_step: 1,
    },
    mutations: {
        [SET_CART_SUMMARY_CHECKOUT_STEP](state, payload) {
            state.cart_summary_checkout_step = payload.step;
        },
        [SHOW_SPLASHSCREEN](state, payload) {
            state.splashscreen_visible = payload.show;
        },
        [SHOW_LOADING](state, payload) {
            state.loading_visible = payload.show;
        },
        [SHOW_MODAL_CART_EXPIRED](state, payload) {
            state.modal_cart_expired_error = payload.error;
            state.show_modal_cart_expired = payload.show;
        },
        [SHOW_MODAL_CART_TIMER](state, payload) {
            state.modal_cart_timer_minutes = payload.minutes;
            state.show_modal_cart_timer = payload.show;
        },
        [SHOW_MODAL_CART_RESET](state, payload) {
            state.show_modal_cart_reset = payload.show;
            state.modal_cart_reset_callback = payload.callback;
        },
        [SHOW_MODAL_ERRORS](state, payload) {
            state.show_modal_errors = payload.show;
            state.modal_errors_title = payload.title;
            state.modal_errors_errors = payload.errors;
        }
    },
    actions: {
        showSplashscreen({commit, state}, show) {
            commit({
                type: SHOW_SPLASHSCREEN,
                show
            })
        },
        showLoading({commit, state}, show) {
            commit({
                type: SHOW_LOADING,
                show
            })
        },
        showModalCartExpired({commit}, payload) {
            commit({
                type: SHOW_MODAL_CART_EXPIRED,
                show: payload.show,
                error: payload.error
            })
        },
        showModalCartTimer({commit}, payload) {
            commit({
                type: SHOW_MODAL_CART_TIMER,
                show: payload.show,
                minutes: payload.minutes
            })
        },
        showModalCartReset({commit}, payload) {
            commit({
                type: SHOW_MODAL_CART_RESET,
                callback: payload.callback,
                show: payload.show
            });
        },
        showModalErrors({commit}, payload) {
            commit({
                type: SHOW_MODAL_ERRORS,
                title: payload.title,
                errors: payload.errors,
                show: payload.show !== undefined ? payload.show : true
            });
        },
        setCartSummaryCheckoutStep({commit}, step) {
            commit({
                type: SET_CART_SUMMARY_CHECKOUT_STEP,
                step
            });
        }
    }

};

export default global;
